import { DefaultCellHeader } from "app/components/React/Table/headerCells";
import { DefaultCellRightAlign } from "app/components/React/Table/cells";
import { i18nFilter } from "app/filters/i18nFilter";
import { PercentageCellRightAlign } from "app/components/React/Table/cells/PercentageCell";
import { DomainListWithTooltip } from "app/components/React/Table/cells/DomainListWithTooltip/DomainListWithTooltip";
import { WithCellOpacityHOC } from "app/components/React/Table/cells/WithCellOpacityHOC";

const i18n = i18nFilter();

export const getColumns = (sortedColumn, isSingleMode: boolean) => {
    // In case we're in single mode - then it means that the table
    // contains sites with auto-suggestions. so we should provide all table data
    // with opacity set to 40%. (product request)
    const columnsOpacity = isSingleMode ? 0.4 : 1;

    return [
        {
            field: "overlappedDomains",
            displayName: i18n("audience.overlap.table.columns.overlapped.domains"),
            tooltip: i18n("audience.overlap.table.columns.overlapped.domains.tooltip"),
            headerComponent: DefaultCellHeader,
            cellComponent: DomainListWithTooltip,
            sortable: true,
            minWidth: 120,
        },
        {
            field: "share",
            displayName: i18n("audience.overlap.table.columns.share"),
            tooltip: i18n("audience.overlap.table.columns.share.tooltip"),
            headerComponent: DefaultCellHeader,
            cellComponent: WithCellOpacityHOC(PercentageCellRightAlign, columnsOpacity),
            percentageCellFilterFraction: 1,
            width: 128,
            showTooltip: true,
            sortable: true,
        },
        {
            field: "overlappedUnique",
            displayName: i18n("audience.overlap.table.columns.overlapped.unique"),
            tooltip: i18n("audience.overlap.table.columns.overlapped.unique.tooltip"),
            headerComponent: DefaultCellHeader,
            cellComponent: WithCellOpacityHOC(DefaultCellRightAlign, columnsOpacity),
            format: "minVisitsAbbr",
            width: 180,
            sortable: true,
        },
        {
            field: "exclusiveUnique",
            displayName: i18n("audience.overlap.table.columns.exclusive.unique"),
            tooltip: i18n("audience.overlap.table.columns.exclusive.unique.tooltip"),
            headerComponent: DefaultCellHeader,
            cellComponent: WithCellOpacityHOC(DefaultCellRightAlign, columnsOpacity),
            format: "minVisitsAbbr",
            width: 250,
            sortable: true,
        },
        {
            field: "unreached",
            displayName: i18n("audience.overlap.table.columns.unreached"),
            tooltip: i18n("audience.overlap.table.columns.unreached.tooltip"),
            headerComponent: DefaultCellHeader,
            cellComponent: WithCellOpacityHOC(DefaultCellRightAlign, columnsOpacity),
            format: "minVisitsAbbr",
            width: 120,
            sortable: true,
        },
    ].map((col) => {
        const { field, sortDirection } = sortedColumn;
        const isSorted = sortedColumn && col.field === field;
        return {
            ...col,
            visible: true,
            isSorted,
            sortDirection: isSorted ? sortDirection : "desc",
        };
    });
};
